import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { DeferImageLoadDirective } from '@app/shared/directives/defer-image-load.directive';
import { ScrollWrapperComponent } from '@app/core/components/wrappers/scroll-wrapper/scroll-wrapper.component';

@Component({
    selector: 'whats-on-your-mind-banner',
    standalone: true,
    imports: [ScrollWrapperComponent, NgTemplateOutlet, DeferImageLoadDirective],
    templateUrl: './whats-on-your-mind-banner.component.html',
    styleUrl: './whats-on-your-mind-banner.component.scss'
})
export class WhatsOnYourMindBannerComponent implements OnInit {
    @Input() isMobile = false;
    @Input() banners = [];
    @Output() openActionLink = new EventEmitter<{ banner: any; index: number }>();

    firstRowBanners = [];
    secondRowBanners = [];

    ngOnInit(): void {
        this.processwhatsOnYourMindBanners();
    }

    processwhatsOnYourMindBanners() {
        const { isMobile, banners } = this;

        if (isMobile && banners.length > 8) {
            this.firstRowBanners = [];
            this.secondRowBanners = [];

            banners.forEach((banner, index) => {
                (index % 2 === 0 ? this.firstRowBanners : this.secondRowBanners).push(banner);
            });
        } else {
            this.firstRowBanners = banners;
            this.secondRowBanners = [];
        }
    }

    handleClick(banner: any, index: number) {
        this.openActionLink.emit({ banner, index });
    }
}
